import { GeneralApi } from 'clientSDK';

const generalApi = new GeneralApi();

export default {
  prices: async () => {
    try {
      const prices = await generalApi.getPrices();
      return prices;
    } catch (error) {
      console.error('Failed to fetch prices:', error);
      throw error;
    }
  },
};
